// EXAMPLE USAGE:
// getTween(sprite, {x: 50, y: 50}, 150, create.Ease.linear, function.bind(this))
//     .update(()=>console.log("event listener"));

export const EASE = {
    "LINEAR":  createjs.Ease.linear,
    "QUAD_I":  createjs.Ease.quadIn,
    "QUAD_O":  createjs.Ease.quadOut,
    "QUAD_IO": createjs.Ease.quadInOut,
    "QUIN_I":  createjs.Ease.quintIn,
    "QUIN_O":  createjs.Ease.quintOut,
    "QUIN_IO": createjs.Ease.quintInOut,
    "SINE_I":  createjs.Ease.sineIn,
    "SINE_O":  createjs.Ease.sineOut,
    "SINE_IO": createjs.Ease.sineInOut,
    "CIRC_I":  createjs.Ease.circIn,
    "CIRC_O":  createjs.Ease.circOut,
    "CIRC_IO": createjs.Ease.circInOut,
    "ELAS_I":  createjs.Ease.elasticIn,
    "ELAS_O":  createjs.Ease.elasticOut,
    "ELAS_IO": createjs.Ease.elasticInOut,
    "BOUN_I":  createjs.Ease.bounceIn,
    "BOUN_O":  createjs.Ease.bounceOut,
    "BOUN_IO": createjs.Ease.bounceInOut,
    "BACK_I":  createjs.Ease.backIn,
    "BACK_O":  createjs.Ease.backOut,
    "BACK_IO": createjs.Ease.backInOut,
    "QUAR_I":  createjs.Ease.quartIn,
    "QUAR_O":  createjs.Ease.quartOut,
    "QUAR_IO": createjs.Ease.quartInOut,
    "CUBI_I":  createjs.Ease.cubicIn,
    "CUBI_O":  createjs.Ease.cubicOut,
    "CUBI_IO": createjs.Ease.cubicInOut,
};

class MyTween {
    // @ts-ignore
    tween: createjs.Tween;

    constructor(obj: object, to: object, time: number, ease: any = EASE.LINEAR, cb = () => {}) {
        this.remove(obj);
        this.tween = createjs.Tween.get(obj)
            .to(to, time, ease)
            .call(() => {
                this.remove(obj);
                cb();
            });
    }

    update(eventL: any) {
        this.tween.addEventListener('change', eventL);
        return this;
    }

    remove(obj: object) {
        createjs.Tween.removeTweens(obj);
    }
}

class MyLoop {
    // @ts-ignore
    tween: createjs.Tween;

    constructor(obj: object, to1: object, to2: object, time: number, ease: any = EASE.LINEAR, onLoop:any = ()=>{}) {
        this.remove(obj);
        this.tween = createjs.Tween.get(obj, {loop: true})
            .to(to1, time/2, ease)
            .to(to2, time/2, ease)
            .call(() => {
                onLoop();
            });
    }

    update(eventL: any) {
        this.tween.addEventListener('change', eventL);
        return this;
    }

    onLoop(func: any) {
        this.tween.onLoop = func;
    }

    remove(obj: any) {
        createjs.Tween.removeTweens(obj);
    }
}

export function getTween(obj: object, to: object, time: number, ease: any = EASE.LINEAR, cb: any = () => {}) {
    return new MyTween(obj, to, time, ease, cb);
}

export function getTweenAsync(obj: object, to: object, time: number, ease: any = EASE.LINEAR, update: any = () => {}) {
    return new Promise<void>(res => {
        new MyTween(obj, to, time, ease, res).update(update);
    });
}

export function getLoop(obj: object, to1: object, to2: object, time: number, ease: any = EASE.LINEAR, onLoop: any) {
    return new MyLoop(obj, to1, to2, time, ease, onLoop);
}